export default "__VITE_ASSET__CxiZ31G3__"